import logoUrl from "../assets/logo.png";
import { cn } from "../lib/utils";

interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  variant?: "default" | "muted";
}

export function Logo({ variant = "default", ...props }: LogoProps) {
  return (
    <img
      {...props}
      src={logoUrl}
      alt="Doe Maar"
      className={cn("max-w-full", variant === "muted" && "grayscale", props.className)}
    />
  );
}
